import { connect } from 'react-redux';

import { getPlainOrganizerEntities } from 'consumer-utils/redux/organizers/selectors';

import {
    addOrganizers,
    popOrganizer,
    followOrganizer,
    viewOrganizerProfile,
} from '../redux/organizers/actions';
import { trackFeedEvent } from '../redux/app/actions';
import OrganizersBucket from '../components/OrganizersBucket';

const _mapStateToProps = (state) => ({
    areProfilesLoading: state.organizers.areProfilesLoading,
    isMobile: state.app.isMobile,
    profiles: getPlainOrganizerEntities(state),
});

const _mapDispatchToProps = {
    handleAddOrganizers: addOrganizers,
    handlePopOrganizer: popOrganizer,
    handleFollowOrganizer: followOrganizer,
    handleViewOrganizer: viewOrganizerProfile,
    trackGAEvent: trackFeedEvent,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(OrganizersBucket);
